import { render } from "./ForgotPasswordSendEmailPage.vue?vue&type=template&id=e12c402e&ts=true"
import script from "./ForgotPasswordSendEmailPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordSendEmailPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__